import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {LoadsService} from "../../services/loads/loads.service";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

    countPending: number = 0;

    cards = [
        {
            url: '/loads/truckLoadList',
            title: 'YURTİÇİ DAĞITIM LİSTESİ',
            icon: 'pi-list',
            count: null
        },
        {
            url: '/loads/stock-inventory',
            title: 'ÜRÜN GİRİŞ LİSTESİ',
            icon: 'pi-list',
            count: null
        },
        {
            url: '/loads/whstocklist',
            title: 'STOK LİSTESİ',
            icon: 'pi-list',
            count: null
        },
        {
            url: '/loads/orders-request',
            title: 'SİPARİŞ TALEP LİSTESİ',
            icon: 'pi-list',
            count: null
        },
        {
            url: 'loads/inlandCargoList',
            title: 'YURTİÇİ KARGO LİSTESİ',
            icon: 'pi-list',
            count: null
        },
        {
            url: '/loads/request-list',
            title: 'TALEP OLUŞTURMA',
            icon: 'pi-plus',
            count: null
        },
        {
            url: '/loads/movement-report',
            title: 'HAREKET RAPORU',
            icon: 'pi-chart-line',
            count: null
        },
        {
            url: '/loads/request-editing',
            title: 'TALEP DÜZENLE',
            icon: 'pi-pencil',
            count: null
        }

    ]
    constructor(public router: Router,private loadsService: LoadsService) { }

    async ngOnInit() {
      this.countPending = await this.loadsService.countWhForwardings('PENDING').toPromise();
      this.cards.push( {
          url: '/loads/pending-request-list',
          title: 'BEKLEYEN TALEPLER',
          icon: 'pi-pencil',
          count: this.countPending,
      })
    }
}
